<template>
  <div class="container">
    <transition name="slide-fade">
      <div class="report-notice" v-show="isShow">
        <div class="report-notice-header">
          <img class="logo fl" src="../assets/images/logo_dark.png" alt="" @click="handleBackIndex">
          <Icon type="close-round" class="close fr" @click.native="isShow=false" size="30"></Icon>
        </div>
        <div class="report-notice-wrapper">
          <h2 class="report-notice-title">举报须知</h2>
          <div class="content-container">
            <div class="content-wrapper" id="wrapper">
              <div class="content" id="content">
                <p class="mb30">“滴滴清风”网站在线举报功能仅用于对滴滴员工、合作伙伴的违规和违纪行为进行举报。与客服有关的问题，如账户恢复服务、服务分、异常扣费等问题，请点击【车主端】-左上角【个人中心】-【服务中心】-【在线客服】按钮，或致电4000000666客服电话咨询。</p>
                <p class="item-title">1. 举报滴滴出行员工受理范围</p>
                <p>a) 向合作伙伴、司机收取或索要任何形式的礼品、现金、馈赠、宴请等。</p>
                <p>b) 侵占、盗用、挪用公司资产和资金，恶意损害公司及第三人利益。</p>
                <p>c) 业务数据、财务数据、费用报销、个人信息、管理信息等故意弄虚作假，协助或指使合作伙伴故意弄虚作假。</p>
                <p>d) 泄露公司机密信息，例如：泄露员工账号权限。</p>
                <p>e) 未按《阳光申报制度》规定履行申报义务。</p>
                <p class="mb30">f) 其他违反国家法律、行政法规等行为。</p>
                <p class="item-title">2.举报滴滴合作伙伴受理范围</p>
                <p>a) 向滴滴出行员工及关联人员（员工亲属或其他与员工有利害关系的人）直接或间接赠送礼金、物品、有价证券或采取其他手段提供不正当利益。</p>
                <p>b) 向滴滴出行提供的信息、文件、资料、数据及相关、陈述和口头陈述，包含虚假、恶意夸大的内容。</p>
                <p>c) 向第三方泄露滴滴出行的商业秘密或掌握的技术、数据信息等。</p>
                <p>d) 向滴滴出行员工提供借贷、融资，负责人及项目关键成员系滴滴出行员工或其关联人员，未提前以书面形式如实、全面地告知滴滴。</p>
                <p>e) 未经授权擅自使用滴滴、DIDI、滴滴出行商标，擅自使用车主俱乐部、授权合作伙伴等容易对外产生混淆的字样、标识。</p>
                <p class="mb30">f) 其他违反国家法律、行政法规的行为。</p>
                <p class="item-title">3.隐私保护</p>
                <p>a) “滴滴清风”鼓励实名举报，您留下联系方式将会有专人与您联系核实并跟进举报线索。</p>
                <p class="mb30">b) “滴滴清风”网站举报渠道、举报邮箱、举报电话均由滴滴出行风控合规部独立管理，对举报信息严格保密。</p>
                <p class="item-title">4.举报人责任</p>
                <p>a) 举报人应当实事求是，保证所举报内容应当提供证据支持。</p>
                <p>b) 禁止虚报和诬告陷害。</p>
                <p>c) 因故意捏造和歪曲事实举报造成的一切后果由举报人自行承担。</p>
              </div>
            </div>
            <div id="track">
              <span id="scrollBar"></span>
            </div>
          </div>
          <div class="btn-wrapper">
            <a href="javascript:;" class="btn" @click="handleAgree">同意</a>
          </div>
        </div>
      </div>
    </transition>
    <div class="report-online">
      <Header :isLight="isLight" :isMenuLight="isMenuLight" class="static-header"></Header>
      <div class="report-online-wapper">
        <h2 class="report-online-title">在线举报</h2>
        <div class="form">
          <Form ref="form" :model="form" :rules="ruleValidate">
            <FormItem prop="type" class="clearfix">
              <!-- <reportSelection :liData="liData" @change="change"></reportSelection> -->
              <!-- 兼容IE -->
              <div class="input-wrapper fl" v-clickoutside="handleClose">
                <!-- 兼容IE -->
                <div class="placeholder" v-if="!form.type" @click="isDropDown=!isDropDown">请选择您要举报的事项</div>
                <Input v-model="form.type" @click.native="isDropDown=!isDropDown" readonly></Input>
                <Icon type="chevron-down" v-show="!isDropDown"></Icon>
                <Icon type="chevron-up" v-show="isDropDown"></Icon>
                <div class="query-type-list-wrapper" v-show="isDropDown">
                  <ul class="query-type-list">
                    <li v-for="(item,index) in list" :key="item.id" class="item" :class="{sleceted:item.sleceted}" @click="handleChoose(index)">
                      <label :id="item.id" class="label">
                        <input type="checkbox" class="checkboxSelect" v-model="item.Check" />
                        <span :class="{checkboxTitle: item.Check}">
                          {{item.dicName}}
                        </span>
                      </label>
                    </li>
                  </ul>
                </div>
              </div>
              <a href="javascript:;" class="fr btn-next" @click="handleNext('form')">下一步</a>
            </FormItem>
            <FormItem prop="password" class="bottom">
              <div class="clearfix agree">
                <Checkbox v-model="agree" class="fl">同意</Checkbox>
                <span class="fl need" @click="isShow=true">举报须知</span>
              </div>
            </FormItem>
          </Form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import dataStatistics from '@/assets/js/dataStatistics'
import { scrollMixin } from '@/mixins/scrollMixin'
import { backIndexMixin } from '@/mixins/backIndexMixin'
import clickoutside from '@/directives/clickoutside'
import Header from '@/components/Header'
import api from '@/api/api'
export default {
  name: 'reportOnline',
  mixins: [scrollMixin, backIndexMixin],
  directives: { clickoutside },
  components: {
    Header
  },

  data() {
    return {
      isShow: true,
      isLight: false,
      isMenuLight: false,
      agree: false,
      isDropDown: false,
      form: {
        type: '',
        reportTypeId: ''
      },
      ruleValidate: {
        type: [{ required: true, message: '请选择举报事项', trigger: 'change' }]
      },
      checkedData: [],
      list: [],
      checkeIdList: []
    }
  },
  created() {
    this.getReportTypeList()
    dataStatistics('PC-选择举报事项页', '进入', '在线举报')
  },
  watch: {
    list: {
      handler(newVal, oldVal) {
        //选中数据
        this.checkedData = newVal.filter(function(item) {
          return item.Check == true;
        });
        //在页面打印出的数据
        this.form.type = ''; //点击的当前项的展示
        this.checkeIdList = []
        for (var i = 0; i < this.checkedData.length; i++) {
          this.form.type += this.checkedData[i].dicName + "  ";
          this.checkeIdList.push(this.checkedData[i].id)
        }
      },
      deep: true
    }
  },
  methods: {
    // 获取举报类型列表
    getReportTypeList() {
      const params = {
        classCode: 'REPORT',
        // isOuter: 0
      }
      api.report.reportTypeList(params).then(res => {
        if (res.data.code === 200) {
          this.list = res.data.data
        }
      })
    },
    // 同意举报须知
    handleAgree() {
      this.isShow = false
      this.agree = true
      if (this.form.type) {
        this.handleNext('form')
      }
    },
    // 关闭下拉列表
    handleClose() {
      this.isDropDown = false
    },
    // 点击下一步
    handleNext(name) {
      console.log(this.checkeIdList)
      //获取链接中的ichannelType参数 举报渠道
      let getUrl = window.location.href
      let paramInfo = new URLSearchParams("?"+getUrl.split("?")[1])
      let channelType = paramInfo.get("channelType")
      // 如果未勾选举报须知，弹出举报须知
      if (!this.agree) {
        this.isShow = true
        return
      }
      this.$refs[name].validate((valid) => {
        if (valid) {
          // 校验通过，跳转到举报内容页
          this.$router.push({
            path: 'reportContent',
            query: {
              channelType: channelType,
              checkeIdList: JSON.stringify(this.checkeIdList)
            }
          })
        } else {

        }
      })
    },
    // 选择列表项
    handleChoose(index) {
      // 如果有外链 新窗口打开链接
      if (this.list[index].url) {
        window.open(this.list[index].url, '_blank')
        return
      }
      this.form.type = this.list[index].dicName
      // 保存id
      this.form.reportTypeId = this.list[index].id
      //激活sleceted 切换样式
      this.list.forEach((item, i) => {
        if (index === i) {
          this.$set(this.list[i], 'sleceted', true)
        } else {
          this.$set(this.list[i], 'sleceted', false)
        }
      })
      // 选中后关闭下拉列表
      // this.isDropDown = false
    }
  }
}
</script>
<style lang="less" scoped>
.report-notice {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  overflow: auto;
  z-index: 2018;
  background: #f5f5f5;
}
.report-notice-wrapper {
  width: 10rem;
  margin: 0 auto;
}
.report-notice-header {
  padding: 0.25rem 0.3rem;
  cursor: pointer;
  .logo {
    height: 48px;
	width: 141px;
  }
  .close {
    cursor: pointer;
  }
}
.report-notice-title {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  font-weight: normal;
  font-family: PingFangSC-Regular;
  font-size: 24px;
  color: #333333;
  text-align: center;
}
.content-wrapper {
  height: 4.2rem;
  overflow: auto;
  margin-right: -17px;
}
.content-container {
  width: 100%;
  overflow: hidden;
  position: relative;
}
.content {
  padding: 0 0.3rem;
  p {
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #666666;
    line-height: 26px;
  }
}
.mb30 {
  margin-bottom: 20px;
}
.btn-wrapper {
  text-align: center;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.btn {
  display: inline-block;
  background: #ff7d41;
  width: 120px;
  height: 38px;
  line-height: 38px;
  color: #fff;
  border-radius: 19px;
  font-size: 14px;
}
#track {
  position: absolute;
  height: 100%;
  width: 10px;
  background: #e7e7e7;
  border-radius: 100px;
  top: 0;
  right: 0;
}
#scrollBar {
  background: #999999;
  border-radius: 100px;
  position: absolute;
  height: 110px;
  width: 4px;
  left: 3px;
  top: 0;
  cursor: pointer;
}

.report-online-wapper {
  width: 9rem;
  margin: 0 auto;
  padding-top: 1.2rem;
}
.report-online-title {
  font-family: PingFangSC-Regular;
  font-size: 0.38rem;
  color: #000000;
  letter-spacing: 1.7px;
  text-align: center;
  font-weight: normal;
  margin-bottom: 1rem;
}
.input-wrapper {
  height: 0.83rem;
  border-top-left-radius: 100px;
  border-bottom-left-radius: 100px;
  overflow: hidden;
  border: 1px solid #313131;
  border-right: none;
  width: 7.2rem;
}
.form {
  /deep/ .ivu-input {
    height: 0.83rem;
    font-family: PingFangSC-Regular;
    font-size: 0.24rem;
    color: #000000;
    border: none;
    box-shadow: 0 0 0 0;
    padding-left: 0.4rem;
    cursor: pointer;
  }
  /deep/ .ivu-form-item-error-tip {
    top: 0.83rem;
    font-size: 0.18rem;
    left: 0.4rem;
  }
}
.btn-next {
  background: #ff7d41;
  border-radius: 0 0.4rem 0.4rem 0;
  width: 1.8rem;
  height: 100%;
  height: 0.83rem;
  line-height: 0.83rem;
  text-align: center;
  font-family: PingFangSC-Regular;
  font-size: 0.24rem;
  color: #ffffff;
}
.bottom {
  text-align: center;
}
.agree {
  display: inline-block;
  font-family: PingFangSC-Regular;
  font-size: 0.2rem;
  color: #333333;

  .need {
    cursor: pointer;
    color: #ff7d41;
  }
}

.query-type-list-wrapper {
  position: absolute;
  top: 0.85rem;
  z-index: 10;
  width: 100%;
  left: 0.4rem;
  // padding-right: 1.8rem;
  width: 6.8rem;
  overflow-y: auto;
  max-height: 3.5rem;
  border: 1px solid #999999;
  border-radius: 3px;
}
.query-type-list {
  background: #ffffff;
  padding: 0.3rem 0;
  .item {
    padding: 0 20px;
    font-size: 0.24rem;
    height: 0.6rem;
    line-height: 0.6rem;
    cursor: pointer;
    &:hover {
      background: #f2f2f2;
    }
    .label{
      display: flex;
      align-items: center;
      .checkboxSelect{
        width: 0.18rem;
        height: 0.18rem;
        margin-right: 5px;
      }
      .checkboxTitle{
        color: #5d88e9;
      }
    }
  }
  .sleceted {
    background: #f2f2f2;
  }
}
.item-title {
  color: #333 !important;
  font-size: 16px !important;
}
.placeholder {
  position: absolute;
  z-index: 12;
  font-size: 0.24rem;
  height: 0.83rem;
  line-height: 0.83rem;
  padding-left: 0.4rem;
  color: #999;
  cursor: pointer;
  -moz-user-select: -moz-none;
-moz-user-select: none;
-o-user-select:none;
-khtml-user-select:none;
-webkit-user-select:none;
-ms-user-select:none;
user-select:none;
 cursor: text;
}
</style>



// WEBPACK FOOTER //
// src/views/ReportOnline.vue